import {
  keepPreviousQueryData,
  useQueryClient,
  useQueryWithUserId,
} from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';
import { IFetchRankReportPayload } from '../types';

/**
 * React query state key for fetch BIDS RANK api it can invalidate
 * the state of bids rank
 */
export const FETCH_BIDS_RANK_QUERY_KEY = 'fetch-bids-rank-query-key';

/**
 * This is used to perform query invalidation for bid details
 */
export const useBidsRankQueryInvalidation = () => {
  const queryClient = useQueryClient();

  const invalidateAllRankFilters = () => {
    queryClient.invalidateQueries({
      queryKey: [FETCH_BIDS_RANK_QUERY_KEY],
    });
  };

  return {
    /**
     * Reset the rank filters to show the updated count of the bids.
     */
    invalidateAllRankFilters,
  };
};

/**
 * React Query hook for bid summary rank api management it will call
 *`fetchRankReports` api and give error loading success state with response
 */
export const useBidsRankQuery = (payload: IFetchRankReportPayload) => {
  const { brandId, brandIds, categoryId, groupIds, search } = payload;

  const localPayload = {
    ...(brandIds && brandIds?.length > 0 ? { brandIds } : {}),
    ...(brandId ? { categoryId } : {}),
    ...(categoryId ? { categoryId } : {}),
    ...(groupIds ? { groupIds } : {}),
    ...(search ? { search } : {}),
  };

  const { data, isError, error, isFetching, isPending, refetch } =
    useQueryWithUserId({
      // eslint-disable-next-line @tanstack/query/exhaustive-deps
      queryKey: [
        FETCH_BIDS_RANK_QUERY_KEY,
        brandId,
        brandIds,
        categoryId,
        groupIds,
        search,
      ],
      queryFn: () => BIDS_API.fetchBidsRanks(localPayload),
      placeholderData: keepPreviousQueryData,
    });

  return {
    data,
    error,
    isError,
    isPending,
    isFetching,
    refetch,
  };
};
